const storage = {
    not_configured: 'Proveedor de almacenamiento no está configurado.',
    missing_parameter: 'Falta el parámetro {{parameter}} para el proveedor de almacenamiento.',
    upload_error: 'Error al cargar el archivo al proveedor de almacenamiento.',
};
export default storage;
